import { render } from "./dairuzhi.vue?vue&type=template&id=001c1e9a&scoped=true"
import script from "./dairuzhi.vue?vue&type=script&lang=js"
export * from "./dairuzhi.vue?vue&type=script&lang=js"

import "./dairuzhi.vue?vue&type=style&index=0&id=001c1e9a&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c1e9a"]])

export default __exports__